import { render, staticRenderFns } from "./DanhSachThanhToan.vue?vue&type=template&id=10571ba9&scoped=true&"
import script from "./DanhSachThanhToan.vue?vue&type=script&lang=js&"
export * from "./DanhSachThanhToan.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachThanhToan.vue?vue&type=style&index=0&id=10571ba9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10571ba9",
  null
  
)

export default component.exports